module.exports = __webpack_public_path__ + "img/create_new_folder.49fc2068.svg";